import {makeStyles} from '@material-ui/core';
import {CremaTheme} from '../../../../types/AppContextPropsType';

const useStyles = makeStyles((theme: CremaTheme) => {
  return {
    appMain: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.default,
      '&.appMainHor': {
        '& .customizerOption': {
          position: 'fixed',
          top: 205,
          [theme.breakpoints.up('xl')]: {
            top: 225,
          },
        },
        '&.appMainFixedFooter': {
          paddingBottom: 48,
          [theme.breakpoints.up('xl')]: {
            paddingBottom: 58,
          },
          '& .footer': {
            borderTop: 'solid 1px',
            borderTopColor: theme.palette.grey[200],
          },
        },
      },
      '& .footer': {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        [theme.breakpoints.up('md')]: {
          marginLeft: 0,
          marginRight: 0,
        },
      },
      '& .footerContainer': {
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingLeft: 16,
        paddingRight: 16,
        [theme.breakpoints.up('lg')]: {
          maxWidth: 1140,
        },
        [theme.breakpoints.up('xl')]: {
          maxWidth: 1720,
        },
      },
    },
    mainContent: {
      flex: 1,
      display: 'flex',
    },
    mainContainer: {
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
      overflow: 'hidden',
      [theme.breakpoints.up('lg')]: {
        maxWidth: 1140,
      },
      [theme.breakpoints.up('xl')]: {
        maxWidth: 1720,
      },
      '& > .scrollbar-container': {
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('md')]: {
          padding: '30px 20px 0',
        },
        '& > div': {
          marginBottom: 0,
        },
      },
    },
    boxedLayout: {
      [theme.breakpoints.up('lg')]: {
        maxWidth: 1260,
        marginLeft: 'auto',
        marginRight: 'auto',
        boxShadow: '0px 0px 4px 2px rgba(0,0,0,0.12)',
        '& .app-sidebar': {
          position: 'absolute',
        },
        '& $mainContent': {
          width: '100%',
          flex: 'auto',
        },
        '& $mainContainer': {
          width: '100%',
        },
        '& .grid-btn': {
          fontSize: 11,
        },
      },
      [theme.breakpoints.up('xl')]: {
        maxWidth: 1680,
        '& $mainContent': {
          width: '100%',
        },
      },
    },
  };
});
export default useStyles;
